<template>
  <div>

      <el-row :gutter="24" style="top:-10px">

        <el-col :span="6">
          县/区：
          <el-select v-model="countyCode" style="width: 60%;" @change="getTowns()">
            <el-option v-for="item in countys" :key="item.unitCode" :label="item.name" :value="item.unitCode">
            </el-option>
          </el-select>

        </el-col>
        <el-col :span="8">
          乡镇/街道：
          <el-select v-model="townCode" style="width: 60%;" @change="getVillages()">
            <el-option v-for="item in towns" :key="item.unitCode" :label="item.name" :value="item.unitCode">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="7">
          村/社区：
          <el-select v-model="villageCode" style="width: 60%;" @change="getData(villageCode)">
            <el-option v-for="item in villages" :key="item.unitCode" :label="item.name" :value="item.unitCode">
            </el-option>
          </el-select>
        </el-col>

      </el-row>

 <el-table :data="DataList"  style="width: 100%" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center'}"
      :row-style="{background:'#F5F7FA'}">


        <el-table-column prop="itemNum" label="项目编号">
        </el-table-column>
        <el-table-column prop="itemName" label="项目名称">
        </el-table-column>
        <el-table-column prop="price" label="价格">
        </el-table-column>
       <el-table-column fixed="right" label="挂牌类型" width="200px">
         <template slot-scope="scope">
           <span v-if="scope.row.priceType==1">元/亩/年</span>
               <span v-if="scope.row.priceType==2">元(总价)</span>
                   <span v-if="scope.row.priceType==3">元/年</span>
         </template>
       </el-table-column>
      <!--  <el-table-column prop="bottomPrice" label="底价">
        </el-table-column>
        <el-table-column prop="currentPrice" label="当前价格">
        </el-table-column> -->

        <el-table-column fixed="right" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button type="success" size="small" plain>查看详情
            </el-button>
            <el-button type="danger"   @click="signUp(scope.row.id)"  size="small" plain>报名
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        unitCode: "410800000000",
        pageNum: 1, // 默认显示第几页
        totalCount: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        DataList: [],
        countys:[],
        towns:[],
        villages:[],
        countyCode:"",
        townCode:"",
        villageCode:"",
        type:"",


      }
    },
    created() {
      this.getCountys();
      this.getData(this.unitCode);
    },
    methods: {
     signUp(projectId){
       this.$http.put("/web/signUp?id="+projectId).then((res) => {
             if(res.data.msg=="success"){
              this.$message.success("报名成功");
             }
             else{
                 this.$message.success(res.data.msg)
             }
            // window.sessionStorage.getItem("token");

       });
     },
      async getCountys() {
        const {
          data: res
        } = await this.$http.get("web/unitCode/getXians/410800000000");
        this.countys = res.data;
       this.getData(this.countyCode)
      },
      async getTowns() {
        const {
          data: res
        } = await this.$http.get("web/unitCode/getXiangs/" + this.countyCode);
        this.towns = res.data;
        this.getData(this.countyCode)
      },
      async getVillages() {
        const {
          data: res
        } = await this.$http.get("web/unitCode/getCuns/" + this.townCode);
        this.villages = res.data;
        this.getData(this.townCode)

      },
      async getData(unitCode) {

        var num = this.pageNum;
        // if (this.pageNum != 0) {
        //   num = this.pageNum - 1;
        // }
        const {
          data: res
        } = await this.$http.get('/web/itemList?pageNum=' + num + "&pageSize=" + this
          .pageSize +"&type="+this.type+ "&unitCode=" +unitCode);
        this.DataList = res.data.list;
        this.totalCount = res.data.total;
        console.log(res);
      },
      async searchData(unitCode) {
        this.searchUnitCode = unitCode;
        this.getData();
      },

      // 每页显示的条数，选择每页条数的时候执行
      handleSizeChange(val) {
        this.pageSize = val // 改变每页显示的条数
        this.searchData(this.searchUnitCode);
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        console.log("handleCurrentChange")
        this.pageNum = val; // 改变默认的页数
        this.searchData(this.searchUnitCode);
      },

    },


  }
</script>

<style lang="scss" scoped="">
  .select {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .lable {
    width: 83px;
    color: black;
    font-size: 15px;
    float: left;
    line-height: 40px;
    text-align: right;
  }

  .inp {
    width: 48%;
    height: 32px;
    border: 1px solid #ccc;

  }



  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
